<kendo-dropdownbutton
  look="bare"
  class="user-ddl"
  [ngClass]="{ 'avatar-only': !showName }"
  buttonClass="d-block user-btn"
  listClass="testdropdown"
  [data]="data"
  (itemClick)="onDropdownButtonItemClick($event)"
  [popupSettings]="{
    popupClass: 'user-button-options',
    anchor: anchor
  }"
  >
  <span class="user-trigger">
    <span class="user-initials" [attr.title]="displayName" aria-hidden="true">{{ initials }}</span>
    @if (showName) {
      <span class="user-text">
        <span class="user-name">{{ displayName }}</span>
        @if (roleName) {
          <span class="user-role">{{ roleName }}</span>
        }
      </span>
    }
  </span>
  <ng-template kendoDropDownButtonItemTemplate let-dataItem>
    <label class="k-checkbox-label">
      {{ dataItem.actionName | translate }}
    </label>
  </ng-template>
</kendo-dropdownbutton>
<!-- <kendo-splitbutton
[data]="data"
buttonClass="btn"
arrowButtonIcon="arrow-60-up"
  [popupSettings]="{
    popupClass: 'user-button-options'
  }"
>
<span class="row position-relative">
  <span class="user-avatar col-auto mt-n2">
    <img [src]="'./assets/images/icons/default-profile.jpg'" alt="" />
  </span>
  <span
    class="account-summary col d-flex flex-column position-static pr-0 pl-3"
    >
    <span class="account-name mx-2"> {{ userInfo?.name }}</span>
  </span>

  <i class="bx bx-chevron-down bx-md mt-1"></i>
</span>
<ng-template kendoSplitButtonItemTemplate let-dataItem>
  <em>{{ dataItem.text }}</em>
</ng-template>
</kendo-splitbutton> -->
